import { z } from 'zod'
import type { FileSelectionPrecondition, FolderPathPrecondition, FolderSelectionPrecondition } from '@/user_files/schemas/preconditions'

// =============================================================================
// Request Types (TypeScript only)
// =============================================================================

export type MoveSelectionRequest = {
  destination_folder_id: string
  file_ids?: string[]
  folder_ids?: string[]
  file_preconditions?: FileSelectionPrecondition[]
  folder_preconditions?: FolderSelectionPrecondition[]
  destination_folder_precondition?: FolderPathPrecondition
}

// =============================================================================
// Response Schemas (Zod - runtime validated)
// =============================================================================

export const MoveSelectionResponseSchema = z.object({
  destination_folder_id: z.string().uuid(),
  moved_file_ids: z.array(z.string().uuid()),
  moved_folder_ids: z.array(z.string().uuid()),
  unchanged_file_ids: z.array(z.string().uuid()),
  unchanged_folder_ids: z.array(z.string().uuid()),
})

export type MoveSelectionResponse = z.infer<typeof MoveSelectionResponseSchema>
